// Hideo - Italian translations: static markup of index.html.
// Keys are the English source strings used in the code (see docs/i18n.md).
import type { Dictionary } from '../types'

const it: Dictionary = {
    "Your content plan, in a moment": "Il tuo PED, in un attimo",
    "Published": "Pubblicati",
    "Scripts and templates": "Script e template",
    "Hooks, opening lines and ideas for your videos": "Ganci, frasi d'apertura e spunti per i tuoi video",
    "What people search for on YouTube, and the keywords to use in your videos": "Cosa cerca la gente su YouTube, e le parole chiave da usare nei tuoi video",
    "All your scripts, including those left without a video, and the templates you saved": "Tutti i tuoi script, anche quelli rimasti senza video, e i template che hai salvato",
    "Competitors and collaborators": "Competitor e collaboratori",
    "Sources, fact-checking and recommended sites": "Fonti, fact-checking e siti consigliati",
    "The guide to every feature of the app": "La guida a tutte le funzioni dell'app",
    "Appearance, language, startup, plan, saving and tags": "Aspetto, lingua, avvio, PED, salvataggi e tag",
    "videos in production": "video in produzione",
    "Text, voice note or image: it goes into the plan, in the \"Idea\" column": "Testo, vocale o immagine: finisce nel PED, colonna \"Idea\"",
    "Put releases and deadlines in your phone's calendar, with reminders": "Metti uscite e scadenze nel calendario del telefono, con i promemoria",
    "On your phone": "Nel telefono",
    "actual delivery · striped bar = overdue": "consegna effettiva · barra a strisce = in ritardo",
    "· drag the bar to move it, the edges to change start or end": "· trascina la barra per spostarla, i bordi per cambiare inizio o fine",
    "Take the guided tour": "Fai il tour guidato",
    "PROJECT": "PROGETTO",
    "Or paste an image URL": "Oppure incolla l'URL di un'immagine",
    "Add a block below": "Aggiungi un blocco sotto",
    "Drag to move · click for the menu": "Trascina per spostare · clic per il menu",
    "Project": "Progetto",
    "Profile: switch, edit, save or load": "Profilo: cambia, modifica, salva o carica",
    "Write your script here... type / for blocks, # for a heading, - for a list": "Scrivi qui il tuo script... digita / per i blocchi, # per un titolo, - per un elenco",
}

export default it
